export default {
  tabTitle: 'Model Composer',
  composeModel: 'Compose Model',
  intro: 'Build a model from channels of your existing models.',
  search: 'Search',
  noModels: 'No composed models yet',
  headerName: 'Name',
  headerCountry: 'Country',
  headerQuality: 'Quality',
  headerCreated: 'Created',
  headerCreatedBy: 'Created by',
  headerStatus: 'Status',
  statusBuilding: 'Building',
  statusReady: 'Ready',
  viewReport: 'View report',
  printJson: 'Print JSON to console',
  deleteModel: 'Delete model',
  deleteDialogTitle: 'Delete model?',
  deleteDialogText: '{name} will be deleted. It can be recovered for 7 days by asking an administrator.',
  deleteDialogTextBuilding: '{name} will be permanently deleted.',
  cancel: 'Cancel',
  delete: 'Delete',
  close: 'Close',
  idCopied: 'ID copied to clipboard',
  snackDeleted: 'Model deleted',
  snackErrorDeleting: 'Error deleting the model',
  relNow: 'now',
  relMinutes: '{n}m',
  relHours: '{n}h',
  relDays: '{n}d',
  relMonths: '{n}mo',
  relYears: '{n}y'
}
